import { api } from './api';
import { Patient } from '@/types/patient';
import { PaginatedResponse } from '@/helpers/pagination.helper';

const BASE_URL = '/cms/patients';

export async function getPatientById(id: number): Promise<Patient> {
  const response = await api.get<Patient>(`${BASE_URL}/${id}`);
  return response.data;
}

export async function getPatientsFromMissionId(missionId: string): Promise<Patient[]> {
  const response = await api.get<PaginatedResponse<Patient>>(
    `${BASE_URL}/?Mission.id=${missionId}`,
  );

  return response.data.items;
}

export async function updatePatient(id: string, body: Record<string, unknown>): Promise<void> {
  await api.put<void>(`${BASE_URL}/${id}`, body);
}
